import React, { useState } from 'react';
import { FaPlay, FaImage } from 'react-icons/fa';

function MediaCard({ entry, viewType }) {
  const [showFullDescription, setShowFullDescription] = useState(false);

  const getMediaType = (url) => {
    if (!url) return 'unknown';
    const videoExtensions = ['mp4', 'avi', 'mov', 'mkv', 'webm'];
    const ext = url.split('.').pop().toLowerCase();
    return videoExtensions.includes(ext) ? 'video' : 'image';
  };

  const formatDate = (dateStr) => {
    const date = new Date(dateStr);
    return date.toLocaleDateString('en-US', { 
      year: 'numeric', 
      month: 'long', 
      day: 'numeric' 
    });
  };

  // Use mediaUrl from entry, fallback to driveLink for backward compatibility
  const mediaUrl = entry.mediaUrl || entry.driveLink;
  
  // Convert Google Drive URL to embed format
  const getEmbedUrl = (url) => {
    if (!url || !url.includes('drive.google.com')) return url;
    
    // Extract file ID from Google Drive URL
    const fileIdMatch = url.match(/id=([a-zA-Z0-9-_]+)/);
    if (fileIdMatch) {
      const fileId = fileIdMatch[1];
      // Return embed URL that works in iframes
      return `https://drive.google.com/file/d/${fileId}/preview`;
    }
    return url;
  };
  
  const isVideo = getMediaType(mediaUrl) === 'video';
  const isImage = getMediaType(mediaUrl) === 'image';
  const embedUrl = getEmbedUrl(mediaUrl);

  return (
    <div className="bg-white rounded-lg shadow-md overflow-hidden hover:shadow-lg transition">
      <div className={`grid gap-4 p-6 ${mediaUrl ? 'grid-cols-1 md:grid-cols-3' : 'grid-cols-1'}`}>
        {/* Media Section */}
        {mediaUrl ? (
          <div className="md:col-span-1">
            {mediaUrl && mediaUrl.includes('drive.google.com') ? (
              // Use iFrame for Google Drive files
              <div className="relative rounded-lg overflow-hidden aspect-square group cursor-pointer bg-gray-100">
                <iframe
                  src={embedUrl}
                  className="w-full h-full border-0"
                  allowFullScreen
                  title={entry.description}
                />
              </div>
            ) : isVideo ? (
              <div className="relative bg-gray-800 rounded-lg overflow-hidden aspect-square flex items-center justify-center group cursor-pointer">
                <video
                  src={mediaUrl}
                  className="w-full h-full object-cover"
                  controls
                />
                <div className="absolute inset-0 bg-black bg-opacity-30 group-hover:bg-opacity-40 transition flex items-center justify-center">
                  <FaPlay className="text-white text-3xl" />
                </div>
              </div>
            ) : (
              <div className="relative rounded-lg overflow-hidden aspect-square group cursor-pointer bg-gray-100">
                <img
                  src={mediaUrl}
                  alt={entry.description}
                  className="w-full h-full object-cover group-hover:scale-105 transition"
                  onError={(e) => {
                    e.target.alt = 'Failed to load image';
                    e.target.style.display = 'none';
                  }}
                />
                <div className="absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-20 transition flex items-center justify-center">
                  <FaImage className="text-white text-3xl opacity-0 group-hover:opacity-100 transition" />
                </div>
              </div>
            )}
          </div>
        ) : null}

        {/* Content Section */}
        <div className={mediaUrl ? 'md:col-span-2 flex flex-col justify-between' : 'flex flex-col justify-between'}>
          <div>
            <div className="flex items-center gap-2 mb-2">
              <p className="text-gray-600 text-sm">
                📅 {formatDate(entry.date)}
              </p>
              {!mediaUrl && (
                <span className="inline-flex items-center rounded-full bg-blue-100 px-2.5 py-0.5 text-xs font-medium text-blue-800">
                  📝 Milestone
                </span>
              )}
            </div>
            <p className="text-gray-700 whitespace-pre-wrap">
              {showFullDescription || entry.description.length < 150
                ? entry.description
                : entry.description.substring(0, 150) + '...'}
            </p>
            {entry.description.length > 150 && (
              <button
                onClick={() => setShowFullDescription(!showFullDescription)}
                className="text-purple-600 hover:text-purple-800 text-sm font-medium mt-2"
              >
                {showFullDescription ? 'Show Less' : 'Show More'}
              </button>
            )}
          </div>

        </div>
      </div>
    </div>
  );
}

export default MediaCard;
